import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Main from './Views/main/main';
import AllLoiResults from './Views/Result/TextDeLoisresult/loiesresult';
import DetailLois from './Views/textdelois/textdelois';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/Loisresult" element={<AllLoiResults />} />
        <Route path="/article/:id" element={<DetailLois />} />
      </Routes>
    </Router>
  );
}

export default App;
